import { useRef, useState } from "react";
import { useFrame } from "@react-three/fiber";
import { Html } from "@react-three/drei";
import * as THREE from "three";
import { fizz } from "../../lib/audio";

const a = new THREE.Vector3();
const c = new THREE.Vector3();
const n = new THREE.Vector3();
const toCam = new THREE.Vector3();

export function Hotspot({ h, variant, open, setOpen, r }) {
  const ref = useRef();
  const visRef = useRef(true);
  const [vis, setVis] = useState(true);
  const [flip, setFlip] = useState(false);

  useFrame(({ camera, size }) => {
    if (!ref.current) return;
    ref.current.getWorldPosition(a);
    ref.current.parent.getWorldPosition(c);
    n.copy(a).sub(c).setY(0).normalize();
    toCam.copy(camera.position).sub(a).normalize();
    const v = n.dot(toCam) > 0.25;
    if (v !== visRef.current) {
      visRef.current = v;
      setVis(v);
    }
    const sx = a.clone().project(camera).x;
    const f = sx > 0.2 && size.width > 640;
    if (f !== flip) setFlip(f);
  });

  const isOpen = open === h.id;
  return (
    <group ref={ref} position={[Math.sin(h.angle) * r * 1.04, h.y, Math.cos(h.angle) * r * 1.04]}>
      <Html center zIndexRange={[30, 0]} style={{ opacity: vis ? 1 : 0, transition: "opacity .35s ease", pointerEvents: "none" }}>
        <div className="relative" style={{ pointerEvents: vis ? "auto" : "none" }}>
          <button
            type="button"
            data-testid={`hotspot-${h.id}`}
            aria-expanded={isOpen}
            aria-label={h.title}
            className="hotspot-dot font-mono text-lg"
            onClick={() => { fizz(0.6); setOpen(isOpen ? null : h.id); }}
          >
            {isOpen ? "–" : "+"}
          </button>
          {isOpen && (
            <div className={`hotspot-card ${flip ? "flip" : ""}`} data-testid={`hotspot-card-${h.id}`}>
              <p className="mb-1 font-mono text-[11px] uppercase tracking-[0.22em] text-gold">{h.title}</p>
              <p className="text-white/90">{h.body[variant]}</p>
            </div>
          )}
        </div>
      </Html>
    </group>
  );
}
